import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

/**
 * @file
 * @author zhousheng
 */
import * as React from 'react';
import LocaleContext from './context';
import { changeModalLocale } from '../modal/locale';

var LocaleProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleProvider, _React$Component);

  var _super = _createSuper(LocaleProvider);

  function LocaleProvider(props) {
    var _this;

    _classCallCheck(this, LocaleProvider);

    _this = _super.call(this, props);
    changeModalLocale(props.locale.Modal);
    return _this;
  } // componentDidUpdate(prevProps: LocaleProviderProps) {


  _createClass(LocaleProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _a;

      if ((_a = this.props.locale) === null || _a === void 0 ? void 0 : _a.Modal) {
        changeModalLocale(this.props.locale.Modal);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          locale = _this$props.locale,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
        value: _extends(_extends({}, locale), {
          exist: true
        })
      }, children);
    }
  }]);

  return LocaleProvider;
}(React.Component);

export { LocaleProvider as default };
LocaleProvider.defaultProps = {
  locale: {}
};